<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <section id="event" class="event subPageSection">
        <div class="backBg"></div>
        <div class="containerMain">
          <div class="cardList eventList">
            <div class="subPageTitle"><h1>{{ t("home-event-title") }}</h1></div>
            <section class="listTopArea">
              <div class="listCount"><span>{{ eventPage.totalElementCount.toString().padStart(2, '0') }}</span>{{ t("home-event-count", eventPage.totalElementCount) }}</div>
            </section>
            <section class="cardListArea">
              <template v-if="eventList.length > 0">
                <ul class="cardListWrap">
                  <LazyEventCard v-for="(event, index) in eventList" :key="index" :event="event"/>
                </ul>
                <div v-if="!eventPage.last" class="loadBtn" @click.stop="methods.getArticleList()" @dblclick.prevent>{{ t("common-load-more") }}</div>
              </template>
              <div v-else class="listNone">{{ t("home-event-none") }}</div>
            </section>
          </div>
        </div>
      </section>
      <div id="mainFooter"></div>
      <!-- pc 네비게이션 펼칠 때 on 클래스 -->
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {ref, useI18n} from '#imports';
import {useHomeService} from '~/composables/service/useHomeService';
import {ArticleModel} from '~~/package/mapper/home/model/ArticleModel';
import {PageModel} from '~~/package/mapper/common/model/PageModel';
import {RouteName} from '~~/package/enum/RouteName';
import {useSeoMeta} from '~/composables/useSeoMeta';

const {$i18n} = useNuxtApp();
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const homeService = useHomeService();
const { getCanonical, getHreflangLinks } = useSeoMeta();

const eventList = ref<ArticleModel[]>([]);
const eventPage = ref<PageModel<ArticleModel>>(new PageModel<ArticleModel>());

useHead({
  title: 'AI 교육·특강·이벤트 | 코드프레소',
  meta: [
    { name: 'description', content: '코드프레소가 진행하는 온오프라인 특강·워크숍 소식을 확인하세요. AI 활용부터 채용, 리더십까지 다양한 주제를 다룹니다.' },
    { name: 'robots', content: 'index,follow' },
    { property: 'og:title', content: 'AI 교육·특강·이벤트 | 코드프레소' },
    { property: 'og:description', content: '코드프레소가 진행하는 온오프라인 특강·워크숍 소식을 확인하세요. AI 활용부터 채용, 리더십까지 다양한 주제를 다룹니다.' },
    { property: 'og:locale', content: 'ko_KR' },
  ],
  link: [...getHreflangLinks.value, { rel: 'canonical', href: getCanonical.value }],
})

definePageMeta({
  alias: [
    '/en/home/events',
    '/ja/home/events',
    '/ko/home/events',
    '/vi/home/events',
  ],
})

onMounted(() => {
  if(route.query.url) methods.handleOldPageLink();
  else methods.getArticleList();
});

const methods = {
  getArticleList() {
    homeService.getArticleList(eventPage.value.pageNumber + 1, 6, 'EVENT', $i18n.locale.value.toUpperCase()).then(page => {
      eventList.value = [...eventList.value, ...page.data];
      eventPage.value = page;
    });
  },
  handleOldPageLink() {
    homeService.getArticle({link: route.query.url as string}).then(articleData => {
      router.replace({name: RouteName.HomeEventsDetail, params: { eventId: articleData.id }});
    }).catch(() => {
      methods.getArticleList();
      router.replace({...route, query: {}});
    });
  }
}
</script>

<style>
@import "~/assets/scss/event_style.scss";
</style>